<template>
  <ul class="sidebar-menu">
    <SidebarMenuItem v-for="(item, index) in menu" :key="index" :menu-item="item" />
  </ul>
</template>

<script>
import SidebarMenuItem from './SidebarMenuItem.vue';

export default {
  name: 'SidebarMenu',
  components: {
    SidebarMenuItem,
  },
  props: {
    menu: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.sidebar-menu {
  list-style: none;
  padding-left: 0;
}
</style>
